import { rem } from 'polished'
import * as React from 'react'
import styled from 'styled-components'

import { mediaQueryUp } from 'components/utils/breakpoint'
import noop from 'lib/function/noop'
import IconButton from 'LuxKit/Button/IconButton'
import LineAngleLeftBIcon from 'LuxKit/Icons/line/LineAngleLeftBIcon'
import LineAngleRightBIcon from 'LuxKit/Icons/line/LineAngleRightBIcon'

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(4)};
  padding-inline: ${rem(4)};

  ${mediaQueryUp.tablet} {
    padding-inline: ${rem(10)};
  }
`

const Label = styled.div`
  flex: 1;
  min-width: 0;
  text-align: center;
`

interface Props {
  previousLabel: string
  nextLabel: string
  disablePrevious?: boolean
  disableNext?: boolean
  onPrevious?: () => void
  onNext?: () => void
  children: React.ReactNode
}

function CalendarMonthNav(props: Props) {
  const {
    previousLabel,
    nextLabel,
    disablePrevious = false,
    disableNext = false,
    onPrevious = noop,
    onNext = noop,
    children,
  } = props

  return <Root>
    <IconButton
      kind="tertiary"
      variant="default"
      size="small"
      aria-label={previousLabel}
      disabled={disablePrevious}
      onClick={onPrevious}
      data-testid="calendar-previous-month"
    >
      <LineAngleLeftBIcon />
    </IconButton>
    <Label>{children}</Label>
    <IconButton
      kind="tertiary"
      variant="default"
      size="small"
      aria-label={nextLabel}
      disabled={disableNext}
      onClick={onNext}
      data-testid="calendar-next-month"
    >
      <LineAngleRightBIcon />
    </IconButton>
  </Root>
}

export default CalendarMonthNav
